/* istanbul ignore next */
export default class UploadError extends Error {
    constructor(error) {
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        this.response = error.response;
    }
}
